/**
 * Maltese Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const mt: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.funds': 'Fondi',
  'nav.investments': 'Investimenti',
  'nav.investees': 'Riċevituri ta\' investiment',
  'nav.esg': 'ESG Reviżjoni',
  'nav.compliance': 'Konformità',
  'nav.reports': 'Rapporti',
  'nav.settings': 'Settings',
  'nav.users': 'Utenti',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Indikaturi',
  'nav.taxonomy': 'Tassonomija tal-UE',
  'nav.filings': 'Sottomissjonijiet',
  'nav.calendar': 'Kalendarju',
  'nav.submit': 'Ibgħat data',
  'nav.submissions': 'Is-sottomissjonijiet tiegħi',
  'nav.benchmarks': 'Punti ta\' referenza',
  'nav.messages': 'Messaġġi',
  'nav.portfolio': 'Portafoll',
  'nav.performance': 'Prestazzjoni tal-fondi',
  'nav.esgSummary': 'ESG Sommarju',
  'nav.pipeline': 'Pipeline',
  'nav.dueDiligence': 'Due Diligence',
  'nav.impact': 'Metriċi tal-impatt',
  'nav.sdg': 'Immappjar SDG',
  'nav.audit': 'Traċċa tal-awditjar',
  'nav.snapshots': 'Snapshots tad-data',
  'nav.knowledgeGraph': 'Graff tal-għarfien',
  'nav.geographic': 'Ġeografiku',
  'nav.bi': 'BI Studju',
  'nav.ai': 'AI Assistent',
  'nav.tasks': 'Kompiti',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Monitor regolatorju',

  // Common Actions
  'action.create': 'Oħloq',
  'action.edit': 'Editja',
  'action.delete': 'Ħassar',
  'action.save': 'Issejvja',
  'action.cancel': 'Ikkanċella',
  'action.submit': 'Ibgħat',
  'action.approve': 'Approva',
  'action.reject': 'Irrifjuta',
  'action.download': 'Niżżel',
  'action.export': 'Esporta',
  'action.import': 'Importa',
  'action.filter': 'Iffiltra',
  'action.search': 'Fittex',
  'action.refresh': 'Aġġorna',
  'action.close': 'Agħlaq',
  'action.back': 'Lura',
  'action.next': 'Li jmiss',
  'action.previous': 'Ta\' qabel',
  'action.viewAll': 'Ara kollox',
  'action.viewDetails': 'Ara d-dettalji',
  'action.generate': 'Iġġenera',
  'action.signOut': 'Oħroġ',
  'action.addNew': 'Żid ġdid',
  'action.invite': 'Stieden',

  // Statuses
  'status.draft': 'Abbozz',
  'status.submitted': 'Sottomess',
  'status.validated': 'Validat',
  'status.approved': 'Approvat',
  'status.rejected': 'Irrifjutat',
  'status.pending': 'Pendenti',
  'status.inProgress': 'Għaddej',
  'status.overdue': 'Skadut',
  'status.compliant': 'Konformi',
  'status.filed': 'Sottomess',
  'status.active': 'Attiv',
  'status.inactive': 'Inattiv',
  'status.closed': 'Magħluq',
  'status.fundraising': 'Ġbir ta\' fondi',
  'status.investing': 'Investiment',
  'status.harvesting': 'Ħsad',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Ħarsa ġenerali tal-portafoll',
  'dashboard.complianceStatus': 'Status tal-konformità',
  'dashboard.collectionProgress': 'Progress tal-ġbir',
  'dashboard.activityFeed': 'Attività',
  'dashboard.quickActions': 'Azzjonijiet mgħaġġla',
  'dashboard.investmentPipeline': 'Pipeline tal-investiment',
  'dashboard.totalFunds': 'Fondi totali',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Investimenti attivi',
  'dashboard.totalInvestees': 'Riċevituri ta\' investiment',
  'dashboard.recentActivity': 'Attività riċenti',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Total impenjat',
  'lp.capitalCalled': 'Kapital mitlub',
  'lp.distributed': 'Distribwit',
  'lp.netPosition': 'Pożizzjoni netta',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Prestazzjoni tal-fondi',
  'lp.esgSummary': 'ESG Sommarju',
  'lp.reportLibrary': 'Librerija tar-rapporti',
  'lp.taxonomyAligned': 'Allinjat mat-tassonomija',
  'lp.paiCoverage': 'PAI Kopertura',
  'lp.portfolioPerformance': 'Prestazzjoni tal-portafoll LP',

  // Fund Labels
  'fund.name': 'Isem il-fond',
  'fund.code': 'Kodiċi tal-fond',
  'fund.vintage': 'Sena tat-twaqqif',
  'fund.size': 'Daqs tal-fond',
  'fund.targetSize': 'Daqs fil-mira',
  'fund.currency': 'Munita',
  'fund.strategy': 'Strateġija',
  'fund.status': 'Status',
  'fund.sfdrCategory': 'SFDR Kategorija',
  'fund.geographyFocus': 'Fokus ġeografiku',
  'fund.sectorFocus': 'Fokus settorjali',

  // Form Labels
  'form.name': 'Isem',
  'form.email': 'Email',
  'form.country': 'Pajjiż',
  'form.amount': 'Ammont',
  'form.currency': 'Munita',
  'form.date': 'Data',
  'form.description': 'Deskrizzjoni',
  'form.notes': 'Noti',
  'form.type': 'Tip',
  'form.period': 'Perjodu',
  'form.year': 'Sena',
  'form.required': 'Meħtieġ',
  'form.optional': 'Fakultattiv',

  // Table Headers
  'table.fund': 'Fond',
  'table.commitment': 'Impenn',
  'table.called': 'Mitlub',
  'table.distributed': 'Distribwit',
  'table.tvpi': 'TVPI',
  'table.status': 'Status',
  'table.regulation': 'Regolament',
  'table.filingType': 'Tip ta\' sottomissjoni',
  'table.reportingPeriod': 'Perjodu',
  'table.createdAt': 'Maħluq',
  'table.actions': 'Azzjonijiet',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Tassonomija tal-UE',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Kompletezza tad-data',
  'compliance.nextDeadline': 'Skadenza li jmiss',

  // Reports
  'report.quarterly': 'Rapport trimestrali',
  'report.annual': 'Rapport annwali',
  'report.paiStatement': 'PAI Dikjarazzjoni',
  'report.taxonomyReport': 'Rapport tat-tassonomija',
  'report.generatedAt': 'Iġġenerat',
  'report.version': 'Verżjoni',

  // General
  'general.loading': 'Jitgħabba...',
  'general.noData': 'M\'hemm l-ebda data disponibbli',
  'general.error': 'Seħħ żball',
  'general.retry': 'Erġa\' pprova',
  'general.total': 'Total',
  'general.page': 'Paġna',
  'general.of': 'minn',
  'general.showing': 'Qed juri',
  'general.results': 'riżultati',
  'general.language': 'Lingwa',
  'general.english': 'Ingliż',
  'general.french': 'Franċiż',
};
